import React, { useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";

import { messages } from "./Production.messages";
import styles from "./Production.module.scss";
import { Slide1 } from "./slides/Slide1/Slide1";
import { Slide2 } from "./slides/Slide2/Slide2";

interface Production {
  title: string;
}

export const Production: React.FC<Production> = ({ title }) => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);
  const ui = useUi();

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      default:
        return <Slide1 />;
    }
  };

  return (
    <StandardCase
      title={title}
      leftComponent={
        <ui.Scrollbars>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P3_S1_Description) }}
          ></div>
        </ui.Scrollbars>
      }
    >
      <div className={styles.content}>
        {renderSlide()}
        <SwitchOption
          onClick={setSelectedOption}
          activeItem={selectedOption}
          items={[
            {
              name: formatMessage(messages.G4_P3_S1_Tab1Title),
            },
            {
              name: formatMessage(messages.G4_P3_S1_Tab2Title),
            },
          ]}
        />
      </div>
    </StandardCase>
  );
};
